// Короткое сообщение внизу экрана (лимит избранного, сбой). Один на приложение.
// Живая область role="status" стоит в DOM всегда (пустая) — диктор озвучивает текст, появившийся внутри
// неё; область, вставленная вместе с текстом, обычно не читается (HQ-1399). Состояние — {id, text}:
// повтор того же текста — новый id и таймер скрытия с начала.
// Пока видна плашка «нет сети», тост «нет сети» не показываем: плашка уже говорит то же самое (HQ-1659 v2);
// тосты других ошибок стоят над плашкой (Toast.module.css, --offline-h).
// Вид — жёлтый Snackbar Figma с иконкой Info, как плашка «нет сети» (HQ-1975).
import { useSyncExternalStore } from 'react';
import infoIcon from '../assets/states/info.svg';
import styles from './Toast.module.css';

export const TOAST_MS = 3500;
export interface ToastState { id: number; text: string }

let current: ToastState | null = null;
let seq = 0;
let timer: ReturnType<typeof setTimeout> | null = null;
const listeners = new Set<() => void>();

function emit(): void { for (const fn of listeners) fn(); }

/** Текст «нет сети» видимой плашки (ставит OfflineBanner; null — плашки нет): пока она на экране, тот же тост не нужен. */
let bannerText: string | null = null;
const bannerListeners = new Set<() => void>();
const offlineBannerText = () => bannerText;
function subscribeOfflineBanner(cb: () => void): () => void {
  bannerListeners.add(cb);
  return () => { bannerListeners.delete(cb); };
}
export function setOfflineBannerText(next: string | null): void {
  if (next === bannerText) return;
  bannerText = next;
  for (const fn of bannerListeners) fn();
}

/** Тост повторяет плашку «нет сети», которая сейчас на экране. */
const repeatsBanner = (text: string) => bannerText !== null && text === bannerText;

export function toast(text: string): void {
  if (repeatsBanner(text)) return;
  if (timer) clearTimeout(timer);
  current = { id: ++seq, text };
  timer = setTimeout(() => { timer = null; current = null; emit(); }, TOAST_MS);
  emit();
}

export function toastState(): ToastState | null { return current; }

function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

export function ToastHost() {
  const state = useSyncExternalStore(subscribe, toastState, toastState);
  // плашка появилась, пока тост «нет сети» ещё висит, — тост прячем
  const banner = useSyncExternalStore(subscribeOfflineBanner, offlineBannerText, offlineBannerText);
  const shown = state && state.text !== banner ? state : null;
  return (
    <div className={styles.region} role="status" aria-live="polite">
      {shown && (
        <div key={shown.id} className={styles.toast}>
          <img className={styles.icon} src={infoIcon} alt="" aria-hidden="true" width={24} height={24} />
          <span className={styles.text}>{shown.text}</span>
        </div>
      )}
    </div>
  );
}
